  import "./index.css";
  import Card from "../../components/Card";

  const regulatoryInfo = [
    {
      name: "SECP",
      logo: "/img/secp-logo.jpg",
      label: "INCORPORATION",
      number: "INCORPORATION : 0198535",
      link: "/img/DIGITAL-CTC-OF-INCORPORATION-CUIN-0198535-dtd-29-Mar-2022.pdf",
    },
    {
      name: "PSX",
      logo: "/img/PSX-logo.jpg",
      label: "TREC No.",
      number: "TREC No. : 529",
      link: "/img/TREC.pdf",
    },
    {
      name: "NCCPL",
      logo: "/img/ncp-logo.jpg",
      label: "Registration No.",
      number: "C19125",
    },
    {
      name: "CDC",
      logo: "/img/national-dipository-company-logo.jpg",
      label: "Participant ID",
      number: "A19125",
      link: "/img/INDUCTION LETTER CDC.pdf"
    },
    {
      name: "SRB",
      logo: "/img/SRB-Logo.jpg",
      label: "Registration No.",
      number: "S9574109-8",
      link: "/img/SINDH-SALES-TAX-REGISTRATION-CERTIFICATE-2023-1.pdf",
    },
    {
      name: "FBR",
      logo: "/img/FBR-logo.jpg",
      label: "NTN",
      number: "NTN : 9574109-8",
      link: "/img/TAX-CERTIFICATE-ORBIT-2022.pdf",
    },
  ];

  export default function RegulatoryInfo() {
    return (
      <div className="regulatory-content-section">
        <h1 className="page-title">REGULATORY INFO</h1>

        <div className="regulatory-grid">
          {regulatoryInfo.map((item, index) => (
            <Card img={item.logo} h1={item.number} link={item.link} />
          ))}
        </div>
      </div>
    );
  }
